module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fullscreen-overlay-layout', {
    attrs: {
      "title": _vm.getCurrentRT.title
    },
    on: {
      "close": _vm.closeOverlay
    }
  }, [_c('div', {
    staticClass: "tl w-100"
  }, [(_vm.submission.user) ? _c('pl-button', {
    staticClass: "pl-secondary-font",
    nativeOn: {
      "click": function($event) {
        return _vm.closeOverlay.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      In response to " + _vm._s(_vm.submission.user.name) + "'s submission\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('comment-card-list', {
    attrs: {
      "submissionID": _vm.submissionID,
      "listOfComments": _vm.filteredCommentsToShow,
      "commentToAutoExpandID": _vm.topLevelCommentID,
      "commentReplyToHighlightID": _vm.replyCommentID,
      "smallFont": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-45884453!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/individualReplyOverlay.vue
// module id = 1182
// module chunks = 61